import { createNotification } from "../components/Notifications/Notifications";
import { api } from "../App";

import {
    SET_BACKUP_LIST,
    SET_BACKUP_BY_NAME,
    SET_BACKUP_TIME,
} from "./types";


export const getBackup = () => async (dispatch) => {
    try {
        const { data } = await api.get(`/backup_postgres`);
        dispatch({ type: SET_BACKUP_LIST, payload: data });
    } catch (error) {
        createNotification('error', 'Ошибка');
    }
};


export const getBackupByName = (name) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/backup_postgres/${name}`);
        dispatch({ type: SET_BACKUP_BY_NAME, payload: data });
    } catch (ERR) {
    } finally {
    }
}

export const createNewBackup = () => async (dispatch) => {
    try {
        await api.post(`/backup_postgres/create/now`);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getBackup());
    }
};

export const deleteBackup = (name) => async (dispatch) => {
    try {
        await api.delete(`/backup_postgres/${name}`);
        createNotification('success', 'Успешно');
        await dispatch(getBackup());
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    }
};

// Время когда делается бэкап
export const getBackupTime = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/backup_postgres/time`);
        dispatch({ type: SET_BACKUP_TIME, payload: data });
    } catch (ERR) {
    } finally {
    }
}

//изм этого времени
export const editBackupTime = (reqData) => async (dispatch) => {
    try {
        await api.put(`/backup_postgres/time`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    }
};

